import React from 'react';
import { Cancel as CancelIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import StandardButton from './StandardButton';
import type { ButtonProps } from '@mui/material';

type DiscardButtonProps = Omit<ButtonProps, 'variant' | 'startIcon'> & {
  loading?: boolean;
  showIcon?: boolean;
};

const DiscardButton: React.FC<DiscardButtonProps> = ({
  loading = false,
  showIcon = false,
  children,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <StandardButton
      variant="secondary"
      loading={loading}
      startIcon={showIcon && !loading ? <CancelIcon /> : undefined}
      aria-label="Discard changes"
      {...props}
    >
      {children ?? t('common:buttons.discard')}
    </StandardButton>
  );
};

export default DiscardButton;
